import React from 'react';

import { Formik } from 'formik';

import styled from 'styled-components';

import PropTypes from 'prop-types';

import { FormStyled } from './styles';

import imgloading from '../../img/load.gif';

const Loadingbtn = styled.div`
  width: 44px;

  height: 44px;

  background: url(${imgloading}) no-repeat center;

  display: none;
`;

const handleValidate = ({ description }) => {
  const errors = {};

  if (!description) errors.description = 'OBRIGATÓRIO';

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  if (!props.role) {
    await props.onRoleCreation({ ...values });
  } else {
    await props.onRoleUpdate({ ...values });
  }

  setSubmitting(false);

  resetForm();
};

const RoleForm = props => {
  const { role, onRoleDelete } = props;

  return (
    <Formik
      enableReinitialize
      initialValues={{
        description: role && (role.description || ''),
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,

        handleChange,

        handleReset,

        handleBlur,

        errors,

        touched,

        dirty,

        isSubmitting,
      }) => (
        <FormStyled>
          <h1>FUNÇÃO</h1>

          <div className="formData">
            <strong>DESCRIÇÃO</strong>

            <input
              id="description"
              name="description"
              value={values.description}
              onChange={handleChange}
              onBlur={handleBlur}
            />

            {errors.description && touched.description && (
              <span>{errors.description}</span>
            )}
          </div>

          <button type="submit" disabled={isSubmitting}>
            <Loadingbtn className="loadingbtn" />
            SALVAR
          </button>

          <button
            type="button"
            onClick={handleReset}
            disabled={!dirty || isSubmitting}
          >
            CANCELAR
          </button>

          {role && !(role.employee_roles[0] || role.exam_roles[0]) && (
            <button
              type="button"
              onClick={() => {
                onRoleDelete(role.uuid);
              }}
              className="delete"
              style={{ margin: '10px' }}
            >
              EXCLUIR
            </button>
          )}
        </FormStyled>
      )}
    </Formik>
  );
};

RoleForm.propTypes = {
  role: PropTypes.shape({
    uuid: PropTypes.string,
    description: PropTypes.string,
    employee_roles: PropTypes.arrayOf(PropTypes.shape({})),
    exam_roles: PropTypes.arrayOf(PropTypes.shape({})),
  }),

  onRoleDelete: PropTypes.func.isRequired,
};

RoleForm.defaultProps = {
  role: null,
};

export default RoleForm;
